export const buildMainPath = (quickCode, stepName, kind, params) =>
  `/simulations/steps/${stepName}/${kind}/${quickCode}${params ? window.location.search : ''}`;
